import React, { useEffect, useState } from 'react';
import { Card, CardContent, Typography, TextField, Button, Stack, CircularProgress, FormHelperText } from '@mui/material';
import { CountryCodesList } from '../../../../../../Screens/Employees/Components/CountryCodesList';
import CountryCode from '../../../../../../Screens/Employees/Components/CountryCode';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { isInputClean, validatePhoneNumber } from '../../../../../../Utils/helper/commonUtils';
import { AppColors } from '../../../../../../Utils/helper/AppColors';

const InitiateCallCard = ({ onBack, onCall, loading, employee, selectedAssistant, selectedAssistantId }) => {
	console.log('employee---', employee);
	const [phone, setPhone] = useState(employee?.phoneNumber || '');
	const [phoneError, setPhoneError] = useState('');
	const [countryCode, setCountryCode] = useState({});
	const [countryCodeAllInfo, setCountryCodeAllInfo] = useState('');
	const [errors, setErrors] = useState({});

	console.log('all call det', { phone, countryCode, countryCodeAllInfo, errors });

	const handleSubmit = () => {
		console.log('Submitting call with number:');
		if (!phone) {
			setPhoneError('Phone number is required');
			return;
		}

		setPhoneError('');
		let callNumber = employee?.phoneNumber ? employee?.phoneNumber : countryCode?.dial_code + phone;
		onCall(callNumber);
	};

	const setError = (e) => {
		if (e.target.name == 'phoneNumber' && (!validatePhoneNumber(e.target.value) || !isInputClean(e.target.value))) {
			setErrors({ ...errors, [e.target.name]: 'Invalid phone number' });
		} else {
			setErrors({ ...errors, [e.target.name]: '' });
		}
	};

	useEffect(() => {
		if (employee?._id) {
			// const user = user;
			const countryName = employee?.country;

			// console.log('countryName', countryName);

			const foundCountry = CountryCodesList.find((c) => c.name.toLowerCase() === countryName?.toLowerCase());

			let cleanedPhoneNumber = employee?.phoneNumber;

			if (foundCountry?.dial_code && cleanedPhoneNumber?.startsWith(foundCountry.dial_code)) {
				cleanedPhoneNumber = cleanedPhoneNumber.slice(foundCountry.dial_code.length);
			}

			// console.log('foundCountry', foundCountry);

			if (foundCountry) {
				setCountryCode(foundCountry);
			}
		}
	}, [employee]);

	return (
		<Card
			sx={{
				borderRadius: 3,
				boxShadow: 2,
				width: '100%',
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				p: 2,
			}}
		>
			<CardContent width="100%">
				<Typography sx={{ fontWeight: 700, fontSize: { sm: '24px', md: '32px' }, color: '#111111', lineHeight: '32px', textAlign: 'center' }} mb={{ sm : 1, md : 2}}>
					Initiate Your Call
				</Typography>
				<Typography sx={{ fontWeight: 400, fontSize: { sm: '16px', md: '18px' }, color: '#777777', textAlign: 'center', mb: 5 }}>
					Ready to connect? Start your direct call with a HR agent.
				</Typography>

				{/* Employee Details */}
				<Stack mb={{xs : 3 , md : 5}} spacing={2} direction={'column'}>
					<Stack sx={{ display: 'flex', flexDirection: {sm : 'column' , md : 'row'}, alignItems: 'start', justifyContent: 'space-between' }}>
						<Typography sx={{ fontWeight: 600, fontSize: '14px', color: '#111111' }}>Name</Typography>
						<Typography sx={{ fontWeight: 400, fontSize: '14px', color: '#777777' }}>
							{employee?.firstName + ' ' + employee?.lastName}
						</Typography>
					</Stack>
					<Stack sx={{ display: 'flex', flexDirection: {sm : 'column' , md : 'row'}, alignItems: 'start', justifyContent: 'space-between' }}>
						<Typography sx={{ fontWeight: 600, fontSize: '14px', color: '#111111' }}>Email </Typography>
						<Typography sx={{ fontWeight: 400, fontSize: '14px', color: '#777777' }}>{employee?.email}</Typography>
					</Stack>

					<Stack sx={{ display: 'flex', flexDirection: {sm : 'column' , md : 'row'}, alignItems: 'start', justifyContent: 'space-between' }}>
						<Typography sx={{ fontWeight: 600, fontSize: '14px', color: '#111111' }}>Department </Typography>
						<Typography sx={{ fontWeight: 400, fontSize: '14px', color: '#777777' }}>{employee?.department}</Typography>
					</Stack>

					<Stack sx={{ display: 'flex', flexDirection: {sm : 'column' , md : 'row'}, alignItems: 'start', justifyContent: 'space-between' }}>
						<Typography sx={{ fontWeight: 600, fontSize: '14px', color: '#111111' }}>Selected Agent</Typography>
						<Typography sx={{ fontWeight: 400, fontSize: '14px', color: '#777777' }}>{selectedAssistant}</Typography>
					</Stack>
					<Stack sx={{ display: 'flex', flexDirection: {sm : 'column' , md : 'row'}, alignItems: { sm : 'start' , md : 'start' }, gap : 2 ,justifyContent: 'space-between' }}>
						<Typography sx={{ fontWeight: 600, fontSize: '14px', color: '#111111' }}>Phone Number</Typography>
						<Stack sx={{ width: { xs : '100%' , md : '50%' }  }}  >
							{
							employee?.phoneNumber ? (
								<TextField variant="outlined" size="small"  sx={{ width: { xs : '100%' , md : '100%' }  }} value={employee?.phoneNumber} disabled={true} />
							) : 
							(
								<Stack sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
									{/* <Typography sx={{ fontWeight: 400, fontSize: '18px', mb: 1 }}>Enter your phone number</Typography> */}
									<TextField
										// required
										// id="outlined-required"
										label="Enter Phone Number"
										helperText={
											phone &&
											phone.length > 0 &&
											(!countryCode?.dial_code ? (
												<FormHelperText sx={{ color: 'red', display: 'flex', alignItems: {xs : 'start' , md : 'start'} }}>
													<span style={{ color: 'red', marginRight: '4px' }}>*</span>
													Please ensure that the phone numbers you provide include the correct country code
												</FormHelperText>
											) : (
												!isValidPhoneNumber(countryCode?.dial_code + phone, countryCodeAllInfo?.code) && (
													<FormHelperText sx={{ color: 'red', display: 'flex', alignItems: 'center' }}>
														<span style={{ color: 'red', marginRight: '4px' }}>*</span>
														Check the phone number you provided, it should be valid for {countryCode?.dial_code}
													</FormHelperText>
												)
											))
										}
										InputLabelProps={{
											// shrink: true,
											sx: { color: AppColors.HEADING_TITLE4 },
										}}
										InputProps={{
											startAdornment: (
												<CountryCode
													countryCode={countryCode}
													setCountryCode={setCountryCode}
													setCountryCodeAllInfo={setCountryCodeAllInfo}
													isNeeded={phone && phone.length > 1 && !countryCode?.dial_code}
												/>
											),
										}}
										onBlur={setError}
										error={errors?.phoneNumber}
										value={phone}
										fullWidth
										placeholder="Enter Phone Number"
										size="small"
										name="phoneNumber"
										focused={phone && countryCode?.dial_code}
										onChange={(e) => {
											const sanitizedValue = e.target.value.replace(/\s/g, ''); // Remove all spaces
											setPhone(sanitizedValue);
											setPhoneError('');
										}}
									/>
								</Stack>
							)}
						</Stack>
					</Stack>
				</Stack>

				<Stack spacing={1}>
					<Button
						variant="contained"
						color="info"
						onClick={() => onBack()}
						disabled={loading}
					>
						{'Back'}
					</Button>
					<Button
						variant="contained"
						color="info"
						onClick={handleSubmit}
						disabled={loading || (!employee?.phoneNumber && !isValidPhoneNumber(countryCode?.dial_code + phone, countryCodeAllInfo?.code)) || !!errors.phoneNumber}
					>
						{loading ? 'Initiating Call...' : 'Call Now'}
					</Button>
				</Stack>
			</CardContent>
		</Card>
	);
};

export default InitiateCallCard;
